var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "67px",
    viewBox: "0 0 50 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lightbulbon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal---clear",
    transform: "translate(-591.000000, -237.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(324.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lightbulbon",
    transform: "translate(268.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5586188,27.201192 C35.0859491,29.5061986 38.9710387,34.9614655 38.9710387,41.3241437 C38.9710387,49.7714397 32.1231523,56.6193261 23.6758563,56.6193261 C15.2285603,56.6193261 8.38067391,49.7714397 8.38067391,41.3241437 C8.38067391,34.9614655 12.2657635,29.5061986 17.7930938,27.201192 L17.7930938,17.7930938 L29.5586188,17.7930938 L29.5586188,27.201192 L29.5586188,27.201192 Z",
    id: "Combined-Shape-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7930938,14.2634364 C17.7930938,12.3140604 19.3798449,10.7337789 21.3231393,10.7337789 L26.0285733,10.7337789 C27.9781636,10.7337789 29.5586188,12.318027 29.5586188,14.2634364 L29.5586188,17.7930938 L17.7930938,17.7930938 L17.7930938,14.2634364 Z",
    id: "Rectangle-90-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6758563,17.7930938 L23.6758563,34.2648287",
    id: "Path-79-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9696463,35.4413812 L28.3820663,35.4413812",
    id: "Path-80-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6758563,10.7337789 L23.6758563,0.0796429383",
    id: "Path-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5006962,41.3241437 L47.3517464,41.3241437 M36.9870282,54.6353156 L40.4172387,58.0655261 M23.6758563,60.1489836 L23.6758563,65.0000338 M10.3646844,54.6353156 L6.93447388,58.0655261 M4.85101643,41.3241437 L-3.37700459e-05,41.3241437 M10.3646844,28.0129718 L6.93447388,24.5827613 M36.9870282,28.0129718 L40.4172387,24.5827613",
    id: "Path-82"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.6c3adc5225ce0f4f09d91c014947e2a6.svg";
export { ForwardRef as ReactComponent };